// useHeaderSetup.js
import React, { useLayoutEffect } from 'react';
import { StyleSheet } from 'react-native';

import { CommonProperties, Color } from '../styles';
import BaseText from '../components/BaseText';
import { scale } from './scale.utils';
import { HeaderBackButton } from '@react-navigation/elements';

const HeaderTitle = ({ reportNumber, fromExistingReport, fromDrawer, isCreationForm }) => {
  const getTitleAndStyle = () => {
    const fromExistingreportAndUpdateSettings = {
      title: reportNumber,
      titleStyle: { ...styles.header, ...styles.boldFontWeight },
    };
    if (fromExistingReport) {
      return fromExistingreportAndUpdateSettings;
    }
    if (fromDrawer) {
      return { title: 'Create New Expense', titleStyle: styles.header };
    }
    if (isCreationForm) {
      return { title: 'Complete your expense', titleStyle: styles.header };
    } else {
      return fromExistingreportAndUpdateSettings;
    }
  };

  const { title, titleStyle } = getTitleAndStyle();

  return <BaseText style={titleStyle}>{title}</BaseText>;
};

const useExpenseHeaderSetup = ({
  navigation,
  reportNumber = '',
  fromExistingReport = false,
  fromDrawer = false,
  isCreationForm = false,
}) => {
  useLayoutEffect(() => {
    navigation.setOptions({
      headerLeft: (headerLeftProps) => (
        <HeaderBackButton {...headerLeftProps} labelVisible={false} />
      ),
      headerTitle: () => (
        <HeaderTitle
          reportNumber={reportNumber}
          fromExistingReport={fromExistingReport}
          fromDrawer={fromDrawer}
          isCreationForm={isCreationForm}
        />
      ),
      headerTitleAlign: 'center',
    });
  }, [navigation, reportNumber, fromExistingReport, fromDrawer, isCreationForm]);
};

const styles = StyleSheet.create({
  header: {
    color: Color.black,
    ...CommonProperties.fontFamily,
    fontSize: scale(18),
  },
  boldFontWeight: {
    fontWeight: 'bold',
  },
});

export default useExpenseHeaderSetup;
